import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import { SnackbarProvider } from 'notistack';

import FormsList from './App/forms/ViewForms/FormsList';
import ApplicationList from './App/forms/ApplicationForm/ApplicationsList';
import ProgrammeManagement from './App/components/ProgrammeManagement';
import { Login, Dashboard } from './App/users';
import { ManagementDashboard } from './App/management';
import { ProtectedRoute, PublicRoute, AdminRoute, StaffRoute, ApplicantRoute } from './App/users/ProtectedRoute';
import { AuthProvider } from './App/users/AuthContext';
import SessionWarningDialog from './App/users/SessionWarningDialog';
import MainLayout from './App/components/MainLayout';
import DashboardOverview from './App/components/DashboardOverview';
import ApplicationMenu from './App/forms/ApplicationForm/ApplicationMenu';
import UserProfile from './App/components/UserProfile';
import ApplicantLogin from './App/forms/ApplicantAuth/ApplicantLogin';
import ApplicantRegister from './App/forms/ApplicantAuth/ApplicantRegister';
import ApplicantDashboard from './App/forms/ApplicantAuth/ApplicantDashboard';
import ApplicantFormList from './App/forms/ApplicantAuth/ApplicantFormList';
import ApplicantFormView from './App/forms/ApplicantAuth/ApplicantFormView';

import ApplicantNoticesManagement from './App/management/ApplicantNoticesManagement';
import FormViewer from './App/forms/ViewForms/FormViewer';



function App() {

return (
		<SnackbarProvider 
			maxSnack={3}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}>	

					<AuthProvider>
				<Router>
					<Routes>
						{/* Staff Login route */}
						<Route path="/login" element={
							<PublicRoute>
								<Login />
							</PublicRoute>
						} />
						
						{/* Applicant Authentication routes */}
						<Route path="/applicant/login" element={
							<PublicRoute>
								<ApplicantLogin />
							</PublicRoute>
						} />
						<Route path="/applicant/register" element={
							<PublicRoute>
								<ApplicantRegister />
							</PublicRoute>						
						} />
						{/* Applicant Dashboard - separate from staff system */}
						<Route path="/applicant/dashboard" element={
							<ApplicantRoute>
								<ApplicantDashboard />
							</ApplicantRoute>
						} />
						<Route path="/applicant/forms" element={
							<ApplicantRoute>
								<ApplicantFormList />
							</ApplicantRoute>
						} />
						<Route path="/applicant/form/:formId" element={
							<ApplicantRoute>
								<ApplicantFormView />
							</ApplicantRoute>
						} />
						
						{/* Protected staff routes with layout wrapper */}
						<Route path="/*" element={
						<ProtectedRoute>
							<MainLayout>							
								<Routes>
									{/* Public dashboard routes */}
									<Route path="/" element={<DashboardOverview />} />
									<Route path="/dashboard" element={<DashboardOverview />} />
									<Route path="/profile" element={<UserProfile />} />
									
									{/* Registry routes - Staff and Admin only */}
									<Route path="/application/form/view" element={
										<StaffRoute>
											<FormViewer/>
										</StaffRoute>
									} />
									<Route path="/forms" element={
										<StaffRoute>
											<FormsList />
										</StaffRoute>
									} />
									<Route path="/app-menu" element={
										<StaffRoute>
											<ApplicationMenu />
										</StaffRoute>
									} />									
									<Route path="/app" element={
										<StaffRoute>
											<FormsList initialView="APPLICATION_TYPES" />
										</StaffRoute>
									} />
									<Route path="/programmes" element={
										<StaffRoute>
											<ProgrammeManagement />
										</StaffRoute>
									} />
									<Route path="/applicant-notices-management" element={
										<StaffRoute>
											<ApplicantNoticesManagement />
										</StaffRoute>
									} />
											{/* User Management routes - Admin only */}
									<Route path="/management" element={
										<AdminRoute>
											<ManagementDashboard />
										</AdminRoute>
									} />
									<Route path="/user-management" element={
										<AdminRoute>
											<ManagementDashboard />
										</AdminRoute>
									} />
									<Route path="/users-page" element={
										<AdminRoute>
											<ManagementDashboard />
										</AdminRoute>
									} />
									<Route path="/users" element={
										<AdminRoute>
											<ManagementDashboard />
										</AdminRoute>
									} />
									<Route path="/groups-page" element={
										<AdminRoute>
											<ManagementDashboard />
										</AdminRoute>
									} />
									<Route path="/groups" element={
										<AdminRoute>
											<ManagementDashboard />
										</AdminRoute>
									} />
									{/* Legacy Dashboard - keeping for compatibility */}
									<Route path="/legacy-dashboard" element={
										<AdminRoute>
											<Dashboard />
										</AdminRoute>
									} />
								</Routes>
							</MainLayout>
						</ProtectedRoute>
					} />
				</Routes>
				<SessionWarningDialog />
			</Router>
		</AuthProvider>
	</SnackbarProvider>
);
}
export default App;
